import { Component, OnInit } from '@angular/core';
import { SoundService } from 'src/app/modules/core/services/parameter/sound/sound.service';
import { SoundManagerService } from 'src/app/modules/core/services/sound-manager/sound-manager.service';

@Component({
  selector: 'app-navbar-option-sound',
  templateUrl: './navbar-option-sound.component.html',
  styleUrls: ['./navbar-option-sound.component.scss']
})
export class NavbarOptionSoundComponent implements OnInit {

  public imageKey: string;
  public showTooltip: boolean;

  constructor(
    private soundService: SoundService,
    private soundManagerService: SoundManagerService
  ) {
    this.showTooltip = false;
  }

  /**
   * Initialize app
   */
  public ngOnInit(): void {
    this.imageKey = `sound-${this.soundService.get() ? 'on' : 'off'}`;

    this.soundService.getObservable().subscribe((enabled: boolean) => {
      this.imageKey = `sound-${enabled ? 'on' : 'off'}`;
    });
  }

  /**
   * Function to enable or disable the sounds
   */
  public toggleSound(): void {
    this.soundManagerService.toggleSound();
  }

}
